import React from "react";

const AutosuggestLoadMoreOption = () => (
  <div className={"search-autosuggest__option"}>
    <div style={{ flex: "0.6 1 0%" }}>Load More...</div>
  </div>
);

export default AutosuggestLoadMoreOption;
